<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/startup/trilha'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para listagem de cursos"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui você pode conferir todos os materiais disponibilizados no
              curso <b>{{ course.title }}</b
              >. Pelo painel você pode assitir os vídeos, responder as
              avaliações e visualizar os materiais complementares.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div
            class="card card-profile shadow vld-parent border-0"
            ref="course_container"
          >
            <div class="card-image">
              <img
                class="card-img-top rounded-top"
                :src="course.image_url || placeholderImg"
                alt="Imagem curso"
              />
              <div class="image-overlay"></div>
            </div>
            <div class="card-body py-3 px-3">
              <h2 class="card-title mb-1">
                <span title="Título do curso">{{ course.title }}</span>
              </h2>
              <p class="description mb-1">
                <span title="Subtítulo do curso">{{ course.subtitle }}</span>
              </p>
              <h5 class="font-weight-300 mt-2 mb-1" v-if="course.presenter">
                Apresentado por: {{ course.presenter }}
              </h5>
              <div v-if="course.description">
                <hr class="my-4" />
                <h5 class="font-weight-300">Descrição</h5>
                <p class="description mb-1 pl-2">{{ course.description }}</p>
              </div>
              <div v-if="course.goals">
                <hr class="my-4" />
                <h5 class="font-weight-300">Objetivos</h5>
                <p class="description mb-1 pl-2">{{ course.goals }}</p>
              </div>
              <div v-if="course.requirements">
                <hr class="my-4" />
                <h5 class="font-weight-300">Requisitos</h5>
                <p class="description mb-1 pl-2">{{ course.requirements }}</p>
              </div>
            </div>
            <div class="card-footer text-center">
              <h5 class="font-weight-300 mt-2 mb-1" v-if="course.updated_at">
                <i class="far fa-clock mr-1"></i> Última atualização:
                {{ formatTimestamp(course.updated_at) }}.
              </h5>
            </div>
          </div>
        </div>

        <div class="col-xl-8 vld-parent" ref="sections_container">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Conteúdo do curso</h3>
                </div>
              </div>
            </div>
            <sections-accordion :sections="sections" v-if="!empty" />
            <p class="text-center mb-1" v-else>
              <badge type="primary">Sem módulos para exibição no momento</badge>
            </p>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

import SectionsAccordion from "./SectionsAccordion";

export default {
  components: {
    SectionsAccordion,
  },
  data() {
    return {
      course: "",
      sections: [],
      empty: false,
      placeholderImg: "/img/pages/default_banner_course.jpg",
    };
  },
  async mounted() {
    const loaderCurso = this.$loading.show({
      container: this.$refs.course_container,
      width: 90,
      height: 90,
    });
    const loaderSections = this.$loading.show({
      container: this.$refs.sections_container,
      width: 90,
      height: 90,
      opacity: 0,
    });
    try {
      const { data } = await api.get(
        `/startup/courses/${this.$route.params.id}/materials`
      );
      if (data.course) this.course = data.course;
      if (data.materials) {
        const sections = [];
        if (
          data.materials.without_section &&
          data.materials.without_section.length
        ) {
          sections.push({
            title: "Geral",
            open: false,
            material: data.materials.without_section,
          });
        }
        if (data.materials.with_section && data.materials.with_section.length) {
          sections.push(
            ...data.materials.with_section.map((s) => ({
              ...s,
              open: false,
            }))
          );
        }
        this.sections = sections;
      }
      this.empty = !this.sections.length;
      loaderCurso.hide();
      loaderSections.hide();
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações do curso"
      );
      this.$router.push("/startup/trilha");
    }
  },
  methods: {},
};
</script>
<style scoped>
.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}
</style>
